import React from 'react';

import * as myConstClass from '../../shared/constants/constants';

class RoundScoreRow extends React.Component {

  constructor(props) {
		super(props);
		//this.dummyfunction = this.dummyfunction.bind(this);
	}

	render() {
		//console.log('RoundScoreRow: RENDER')
		return (
			<div className="form-group form-inline">
			<div className="row">

				<div className="form-group form-inline">
				<label> {this.props.matchup.p1Description} </label>
				&nbsp;
				<input className="form-control" type="number" tabIndex="1" 
					name={"p1." + this.props.matchup.round + "." + this.props.matchup.game} 
					value={this.props.matchup.p1Score || 0} onKeyPress={this.props.handleKeyPress}
					onChange={this.props.handleScoreChange}
					onBlur={this.props.handleScoreBlur}>
				</input>
      	</div>
				&nbsp;

				<div className="form-group form-inline">
				<label> {this.props.matchup.p2Description} </label>
				&nbsp;
				<input className="form-control" type="number" tabIndex="2" 
					name={"p2." + this.props.matchup.round + "." + this.props.matchup.game} 
					value={this.props.matchup.p2Score || 0} onKeyPress={this.props.handleKeyPress}
					onChange={this.props.handleScoreChange}
					onBlur={this.props.handleScoreBlur}>
				</input>
      	</div>
				&nbsp;

				{this.erotroCheckbox()}
				{this.tbbCheckbox()}
				{this.tvCheckbox()}

      </div>
      </div>
		);
	}

	erotroCheckbox() {
		if (this.props.leagueType === myConstClass.LGTYPE_8B) {
			return (
				<div className="form-group form-inline">
				<label> ERO </label>
				&nbsp;
				<input type="checkbox" tabIndex="3"
					name={"ero." + this.props.matchup.round + "." + this.props.matchup.game} 
					onChange={this.props.handleEroChange} checked={this.props.matchup.ero || false} ></input>
				&nbsp;
      	</div>
			);
		}

		if (this.props.leagueType === myConstClass.LGTYPE_9B) {
			return;
		}

		if (this.props.leagueType === myConstClass.LGTYPE_10B) {
			return (
				<div className="form-group form-inline">
				<label> TRO </label>
				&nbsp;
				<input type="checkbox" tabIndex="3"
					name={"ero." + this.props.matchup.round + "." + this.props.matchup.game} 
					onChange={this.props.handleEroChange} checked={this.props.matchup.ero || false} ></input>
				&nbsp;
      	</div>
			);
		}
	}

	tbbCheckbox() {
		if (this.props.leagueType === myConstClass.LGTYPE_10B) {
			return (
				<div className="form-group form-inline">
				<label> TBB </label>
				&nbsp;
				<input type="checkbox" tabIndex="4" 
						name={"tbb." + this.props.matchup.round + "." + this.props.matchup.game} 
						onChange={this.props.handleTbbChange} checked={this.props.matchup.tbb || false} />
				&nbsp;
				</div>
			);
		}
	}

	tvCheckbox() {
		if ((this.props.leagueType === myConstClass.LGTYPE_8B) &&
			  (this.props.stateloLeagueParam.indexOf('QVNEA') !== -1)) {

			return (
				<div className="form-group form-inline">
				<label> TV </label>
				&nbsp;
				<input type="checkbox" tabIndex="5" 
						name={"tv." + this.props.matchup.round + "." + this.props.matchup.game} 
						onChange={this.props.handleTvChange} checked={this.props.matchup.tv || false} />
				&nbsp;
				</div>
			);
		}
	}

}

export default RoundScoreRow;